/*用户菜单及按钮权限存储*/
import { setSessionStore, removeSessionStore } from '@/utils/storage'
import { MENUS, MENU_BUTTONS } from '@/store/mutation-types'
const permission = {
    namespaced: true,
    state: {
        // 左侧菜单栏数据
        menuTree: [],
        menusMap: [],
        // 菜单按钮权限
        menuButtons: []
    },
    getters: {
        getMenus(state) {
            function filterMenus(nodes) {
                if (!nodes || !Array.isArray(nodes)) return []
                return nodes
                    .filter(node => node.hidden === 0) // 只显示未隐藏的
                    .map(node => {
                        const menu = { ...node }
                        // 如果有子节点，递归过滤
                        if (menu.children && menu.children.length > 0) {
                            menu.children = filterMenus(menu.children)
                        }

                        return menu
                    })
            }
            return filterMenus(state.menuTree)
        },
        getMenuButtons: (state) => {
            return state.menuButtons
        },
    },
    mutations: {
        SET_MENUS(state, menuTree) {
            setSessionStore(MENUS, menuTree)
            if (typeof menuTree === 'string') {
                state.menuTree = JSON.parse(menuTree)
            }
            else
                state.menuTree = menuTree
        },
        SET_MENUS_MAP(state, map) {
            state.menusMap = map
        },
        SET_MENU_BUTTONS(state, menuButtons) {
            setSessionStore(MENU_BUTTONS, menuButtons)
            if (typeof menuButtons === 'string') {
                state.menuButtons = JSON.parse(menuButtons)
            }
            else
                state.menuButtons = menuButtons
        },
        REMOVE_MENUS: (state) => {
            state.menuTree = null
            removeSessionStore(MENUS)
        },
        REMOVE_MENU_BUTTONS: (state) => {
            state.menuTree = null
            removeSessionStore(MENU_BUTTONS)
        },
    },

    actions: {
        setMenuList({ commit }, menuData) {
            const permissionMap = new Set()
            const buttonPermissions = new Set()
            function extractPermissions(nodes) {
                if (!Array.isArray(nodes) || nodes.length === 0) return;
                nodes.forEach(node => {
                    if (node.hidden === 0) {
                        const menuItem = { ...node };
                        delete menuItem.children
                        permissionMap.add(menuItem)
                    }
                    if (node.hidden === 1 && node.permission) {
                        buttonPermissions.add(node.permission);
                    }
                    if (node.children) {
                        extractPermissions(node.children);
                    }
                });
            }
            if (!Array.isArray(menuData)) {
                console.error('setMenuList: menuData必须是数组类型', menuData);
                return;
            }
            extractPermissions(menuData);
            const buttonPermList = Array.from(buttonPermissions);
            const menusMap = Array.from(permissionMap);
            console.log('按钮权限', buttonPermList)
            commit('SET_MENUS', menuData);
            commit('SET_MENUS_MAP', menusMap);
            commit('SET_MENU_BUTTONS', buttonPermList);
        }
    }
}

export default permission
